import { map } from 'bluebird'
import { compact } from 'lodash'
import { useEffect, useState } from 'react'
import { useGetFileCellDocumentLazyQuery } from '~/common/generated/apollo-operations'
import { FileInlineImage } from '../../table-cells/FileTableCells/FileInlineImage'
import { FileCellDocument } from '../record-cell-details/types'

interface LookupFilesInlineProps {
  documentIds: string[]
}

/**
 * File displays for lookup files inline in a form
 */
export function LookupFilesInline({ documentIds }: LookupFilesInlineProps) {
  const [getFile] = useGetFileCellDocumentLazyQuery()
  const [documents, setDocuments] = useState<FileCellDocument[]>([])

  useEffect(() => {
    const getAllFiles = async (documentIds: string[]) => {
      return map(documentIds, (documentId) => getFile({ variables: { documentId } }))
    }

    getAllFiles(documentIds).then((results) => {
      setDocuments(compact(results.map((result) => result.data?.document)))
    })
  }, [documentIds, getFile])

  return (
    <>
      {documents.map((document) => (
        <FileInlineImage key={document.id} document={document} />
      ))}
    </>
  )
}
